import Info5Content from '../components/info/Info5PageContent';

const Info5Page = () => {
  return <Info5Content />;
};

export default Info5Page;